import * as Headless from '@headlessui/react'
import { Link as InertiaLink } from '@inertiajs/react'
import { forwardRef, type ComponentPropsWithoutRef } from 'react'

type Props = Omit<ComponentPropsWithoutRef<'a'>, 'href'> & {
  href: string
}

export const Link = forwardRef<HTMLAnchorElement, Props>(function Link({ href, children, ...rest }, ref) {
  const external = href.startsWith('http') || href.startsWith('mailto:')

  return (
    <Headless.DataInteractive>
      {external ? (
        <a ref={ref} href={href} {...rest}>
          {children}
        </a>
      ) : (
        <InertiaLink ref={ref} href={href} {...(rest as ComponentPropsWithoutRef<typeof InertiaLink>)}>
          {children}
        </InertiaLink>
      )}
    </Headless.DataInteractive>
  )
})
